import './Background.css';
import cloud1 from '../../images/cloud5.png'
import sunCenter from '../../images/sun-center.png'
import sunRays from '../../images/sun-rays.png'
import React from 'react'

const Background = () => {
  return (
    <div className='background ' data-rellax-speed="5">
        <div className='sky'>
          {/* <div className='cloud-layer'>
            <img src={sunCenter} alt="Sun" className="sun sun-center" />
            <img src={sunRays} alt="Sun" className="sun sun-rays sun-rays-spin" />
            <img src={cloud1} alt="Cloud" className="cloud1" />
            <img src={cloud1} alt="Cloud" className="cloud2" />

          </div> */}
        </div>
        
      </div>
  )
}

export default Background